module.exports = __webpack_public_path__ + "img/setxrm-raporlama.1acb3b90.png";